/* eslint-disable max-lines */
import gql from "graphql-tag.macro";
import { DateTime } from "luxon";
import { fetchDocumentsInAProject } from "Globals/dataTypes/projects/projects.api";
const workflowInstanceFragment = gql`
  fragment workflowInstance on Workflowinstance {
    __typename
    actions {
      edges {
        node {
          _id
          comment
          status
          customstatus
          statusChangedAt
          fulfilledAt
          rejectedAt
          cancelledAt
          kind
          round
          name
          displayname
          displaytype
          description
          identifier
          sendNotification
          customstati
          _parent {
            _id
            kind
            model
          }
        }
      }
    }
    myactions {
      edges {
        node {
          _id
          comment
          status
          customstatus
          statusChangedAt
          fulfilledAt
          rejectedAt
          cancelledAt
          kind
          round
          name
          displayname
          displaytype
          description
          identifier
          sendNotification
          customstati
          _parent {
            _id
            kind
            model
          }
        }
      }
    }
    log {
      data {
        index
        timestamp
        data {
          comment
          who {
            id
            email
            # firstname
            # lastname
          }
          when
          why {
            human
            robot {
              t
              related
              relatedKind
              from
              to
              by
              action {
                kind
                status
              }
            }
          }
          what {
            path
            value
            from
          }
        }
        precedingHash
        hash
      }
    }
    currentStage {
      _id
      name
      description
      nextStages {
        _id
        name
      }
      prevStages {
        _id
        name
      }
      nextStageTransitions {
        to
        name
      }
      prevStageTransitions {
        to
        name
      }
      defaultActionType
      dueDate
      onEnter {
        explicit_deny {
          subject
          kind
          permission
          scope
        }
        createActions {
          kind
          name
          identifier
          customstati
          subject {
            id
            kind
            assignee {
              ... on User {
                firstname
                lastname
              }
              ... on ProjectGroup {
                displayName
                name
              }
            }
          }
        }
      }
      autoprogress {
        nextStage {
          _id
          name
          description
          nextStages {
            _id
            name
          }
          prevStages {
            _id
            name
          }
          defaultActionType
          dueDate
          onEnter {
            createActions {
              kind
              name
              displayname
              displaytype
              description
              identifier
              sendNotification
              customstati
              subject {
                id
                kind
                assignee {
                  ... on User {
                    firstname
                    lastname
                  }
                  ... on ProjectGroup {
                    displayName
                    name
                  }
                }
              }
            }
          }
        }
        conditions {
          assertation {
            ... on ActionAssertation {
              customStatus: customstatus
              type
              status
              count
            }
          }
        }
      }
      exitguards {
        nextStage {
          _id
          name
          description
          nextStages {
            _id
            name
          }
          prevStages {
            _id
            name
          }
          defaultActionType
          dueDate
          onEnter {
            createActions {
              kind
              name
              displayname
              displaytype
              description
              identifier
              sendNotification
              customstati
              subject {
                id
                kind
                assignee {
                  ... on User {
                    firstname
                    lastname
                  }
                  ... on ProjectGroup {
                    displayName
                    name
                  }
                }
              }
            }
          }
        }
        conditions {
          assertation {
            ... on ActionAssertation {
              customStatus: customstatus
              type
              status
              count
            }
          }
        }
      }
    }
    stages {
      _id
      name
      description
      nextStages {
        _id
        name
      }
      prevStages {
        _id
        name
      }
      nextStageTransitions {
        to
        name
      }
      prevStageTransitions {
        to
        name
      }
      defaultActionType
      dueDate
      onEnter {
        explicit_deny {
          subject
          kind
          permission
          scope
        }
        createActions {
          kind
          name
          displayname
          displaytype
          description
          identifier
          sendNotification
          customstati
          subject {
            id
            kind
            assignee {
              ... on User {
                firstname
                lastname
              }
              ... on ProjectGroup {
                displayName
                name
              }
            }
          }
        }
      }
      exitguards {
        nextStage {
          _id
          name
          description
          nextStages {
            _id
            name
          }
          prevStages {
            _id
            name
          }
          defaultActionType
          dueDate
          onEnter {
            createActions {
              kind
              name
              displayname
              displaytype
              description
              identifier
              sendNotification
              customstati
              subject {
                id
                kind
                assignee {
                  ... on User {
                    firstname
                    lastname
                  }
                  ... on ProjectGroup {
                    displayName
                    name
                  }
                }
              }
            }
          }
        }
        conditions {
          assertation {
            ... on ActionAssertation {
              customStatus: customstatus
              type
              status
              count
            }
          }
        }
      }
      exitguards {
        nextStageId
        conditions {
          assertation {
            ... on ActionAssertation {
              customstatus
              type
              status
              count
            }
          }
        }
      }
      autoprogress {
        nextStage {
          _id
          name
          description
          nextStages {
            _id
            name
          }
          prevStages {
            _id
            name
          }
          defaultActionType
          dueDate
          onEnter {
            createActions {
              kind
              name
              displayname
              displaytype
              description
              identifier
              sendNotification
              customstati
              subject {
                id
                kind
                assignee {
                  ... on User {
                    firstname
                    lastname
                  }
                  ... on ProjectGroup {
                    displayName
                    name
                  }
                }
              }
            }
          }
        }
        conditions {
          assertation {
            ... on ActionAssertation {
              customStatus: customstatus
              type
              status
              count
            }
          }
        }
      }
    }
    disabled
    currentStageStartDate
    startDate
    description
    name
    workflowmodelid
    etag
    _id
    defaultRole
    _parent {
      model
      _id
    }
  }
`;

const loadWidgetConfigQuery = gql`
  query loadWidgetConfig {
    currentProject {
      ... on Project {
        _id
        workflowwidgetsetting {
          currentConfiguration {
            requiredRoles
            requiredDenyAssignments
            requiredActions {
              type
              status
            }
            preHeader {
              key
              component
            }
            header {
              key
              component
            }
            summary {
              key
              component
            }
            details {
              key
              component
            }
            footer {
              key
              component
            }
          }
        }
      }
    }
  }
`;

const loadCurrentWorkflowInstanceQuery = gql`
  query loadCurrentWorkflowInstance($id: ID!) {
    v2document(id: $id) {
      workflowinstance {
        ...workflowInstance
      }
    }
  }
  ${workflowInstanceFragment}
`;

const loadCurrentUserActionsQuery = gql`
  query getMyActions {
    myactions {
      edges {
        node {
          _id
          kind
          status
          _parent {
            _id
            kind
            parent {
              ... on Workflowinstance {
                _id
                _parent {
                  _id
                  model
                }
              }
            }
          }
        }
      }
    }
  }
`;

const loadDocGroupQuery = gql`
  query loadDocGroupQuery($docId: String!) {
    docGroup(docId: $docId) {
      id
      name
      description
      lastUpdated
      members {
        _id
        firstname
        lastname
        email
        userContext {
          level
          position
          strengths
        }
        groups {
          ... on ProjectGroup {
            id
            name
            hasRoles
            hasChildGroups
            parentId
          }
        }
      }
      hasRoles
      displayName
      hasChildGroups
      path
      created
      related
      relatedModel
      roles {
        id
        name
        role
      }
    }
  }
`;
const loadAssignableGroupsInProjectQuery = gql`
  query loadAssignableGroupsInProjectQuery {
    assignableGroupsInProject {
      id
      name
      description
      lastUpdated
      members {
        _id
        firstname
        lastname
        email
        userContext {
          level
          position
          strengths
        }
        groups {
          ... on ProjectGroup {
            id
            name
            hasRoles
            hasChildGroups
          }
        }
      }
      hasRoles
      displayName
      hasChildGroups
      path
      created
      related
      relatedModel
      roles {
        id
        name
        role
      }
    }
  }
`;

const loadAvailableUsersInProjectQuery = gql`
  query loadAvailableUsersInProjectQuery {
    availableUsersInProject {
      _id
      firstname
      lastname
      email
      avatar
      userContext {
        level
        position
        strengths
      }
      groups {
        ... on ProjectGroup {
          name
          id
          parentId
          subGroups {
            id
          }
          hasRoles
          hasChildGroups
        }
      }
    }
  }
`;

const loadAllGroupsQuery = gql`
  query loadGroupsInProject {
    currentProject {
      ... on Project {
        _id
        availableusers {
          edges {
            node {
              _id
              firstname
              lastname
              email
              avatar
              groups {
                ... on ProjectGroup {
                  name
                  id
                  subGroups {
                    id
                  }
                  hasRoles
                  hasChildGroups
                }
              }
            }
          }
        }
        groups {
          id
          name
          description
          lastUpdated
          members {
            _id
            firstname
            lastname
            email
            groups {
              ... on ProjectGroup {
                id
                name
                hasRoles
                hasChildGroups
              }
            }
          }
          hasRoles
          displayName
          hasChildGroups
          path
          created
          related
          relatedModel
          roles {
            id
            name
            role
          }
        }
      }
    }
  }
`;

const progressWorkflowInstanceMutation = gql`
  mutation progressWorkflowInstance(
    $comment: String
    $etag: ETAG!
    $id: ID
    $nextStage: ID
    $v2DocumentId: ID
  ) {
    progressWorkflowInstance(
      comment: $comment
      etag: $etag
      id: $id
      nextStage: $nextStage
      v2DocumentId: $v2DocumentId
    ) {
      ...workflowInstance
    }
  }
  ${workflowInstanceFragment}
`;

const regressWorkflowInstanceMutation = gql`
  mutation regressWorkflowInstance(
    $comment: String
    $etag: ETAG!
    $id: ID
    $prevStage: ID
  ) {
    regressWorkflowInstance(
      comment: $comment
      etag: $etag
      id: $id
      prevStage: $prevStage
    ) {
      ...workflowInstance
    }
  }
  ${workflowInstanceFragment}
`;

const forceWorkFlowJumpMutation = gql`
  mutation forceWorkFlowJump(
    $comment: String
    $etag: ETAG!
    $id: ID
    $nextStage: ID
  ) {
    forceWorkFlowJump(
      comment: $comment
      etag: $etag
      id: $id
      nextStage: $nextStage
    ) {
      ...workflowInstance
    }
  }
  ${workflowInstanceFragment}
`;

const processActionMutation = gql`
  mutation processAction($id: ID!, $input: ProcessActionInput!) {
    processAction(id: $id, input: $input) {
      ... on Action {
        _id
        status
        comment
        status
        kind
        customstati
      }
    }
  }
`;

const updateWorkflowInstanceMutation = gql`
  mutation updateWorkflowinstance(
    $id: ID!
    $input: WorkflowinstanceInput!
    $rotateStage: Boolean
  ) {
    updateWorkflowinstance(id: $id, input: $input, rotateStage: $rotateStage) {
      ...workflowInstance
    }
  }
  ${workflowInstanceFragment}
`;

const getRoleQuery = gql`
  query getRole($roleIdentifier: String!) {
    getRole(roleIdentifier: $roleIdentifier) {
      id
      name
      role
      scope
      scopeName
      scopeValue
      composites {
        id
        name
        role
      }
    }
  }
`;

const createRoleMutation = gql`
  mutation createRole($roleName: String!, $rolesIncluded: [String]) {
    createRole(roleName: $roleName, rolesIncluded: $rolesIncluded) {
      id
      name
      role
    }
  }
`;

const addRoleToCompositeMutation = gql`
  mutation addRoleToComposite($roleName: String!, $rolesIncluded: [String]) {
    addRoleToComposite(roleName: $roleName, rolesIncluded: $rolesIncluded) {
      id
      name
      role
    }
  }
`;

const removeRoleFromCompositeMutation = gql`
  mutation removeRoleFromComposite(
    $roleName: String!
    $rolesIncluded: [String!]!
  ) {
    removeRoleFromComposite(
      roleName: $roleName
      rolesIncluded: $rolesIncluded
    ) {
      id
      name
      role
    }
  }
`;

const updateGroupUsersMutation = gql`
  mutation updateGroupUsers(
    $groupId: ID!
    $addUserIds: [ID!]!
    $removeUserIds: [ID!]!
  ) {
    addAndRemoveUsersProjectGroup(
      groupId: $groupId
      addUserIds: $addUserIds
      removeUserIds: $removeUserIds
    ) {
      id
      name
      description
      lastUpdated
      members {
        _id
        firstname
        lastname
      }
      hasRoles
      displayName
      hasChildGroups
      path
      created
    }
  }
`;

const addGroupMutation = gql`
  mutation createProjectGroup($name: String!, $input: ProjectGroupInput) {
    createProjectGroup(name: $name, input: $input, isDocumentGroup: true) {
      id
      name
      description
      lastUpdated
      members {
        _id
        firstname
        lastname
      }
      hasRoles
      displayName
      hasChildGroups
      path
      created
    }
  }
`;

const loadCurrentInstanceQuery = gql`
  query currentInstance {
    currentInstance {
      ... on Instance {
        name
        projects {
          edges {
            node {
              _id
              name
            }
          }
        }
      }
    }
  }
`;

const grantMemberRoleToGroupMutation = gql`
  mutation grantMemberRoleToGroup($roleIdentifier: String!, $groupId: ID!) {
    grantRoleToGroup(roleIdentifier: $roleIdentifier, groupId: $groupId) {
      id
      name
      role
    }
  }
`;

const revokeMemberRoleFromGroupMutation = gql`
  mutation revokeRoleFromGroup($roleIdentifier: String!, $groupId: ID!) {
    revokeRoleFromGroup(roleIdentifier: $roleIdentifier, groupId: $groupId) {
      id
      name
      role
    }
  }
`;

const activeWorkflowModelQuery = gql`
  query activeWorkflowModel {
    currentProject {
      ... on Project {
        activeWorkflowModelId
      }
    }
  }
`;

const activateWorkflowOnDocumentMutation = gql`
  mutation activateWorkflowOnDocument($parentIds: [ID!]!, $workflowmodel: ID!) {
    activeWorkflowOnv2Document(
      parentIds: $parentIds
      workflowmodel: $workflowmodel
    ) {
      ...workflowInstance
    }
  }
  ${workflowInstanceFragment}
`;

const changeDocumentDefaultPermissionMutation = gql`
  mutation changeDocumentDefaultPermission($permission: RoleExpression!) {
    changeDocumentDefaultPermission(permission: $permission) {
      id
      workflowinstance {
        ...workflowInstance
      }
    }
  }
  ${workflowInstanceFragment}
`;

const activateHeadingWorkflowOnDocumentMutation = gql`
  mutation activateWorkflowOnDocument($parentIds: [ID!]!, $workflowmodel: ID!) {
    activeWorkflowOnv2Heading(
      mode: IGNORE_ALREADY_INITILIZED
      parentIds: $parentIds
      workflowmodel: $workflowmodel
    ) {
      ...workflowInstance
    }
  }
  ${workflowInstanceFragment}
`;

const archiveHeadingWorkflowMutation = gql`
  mutation archiveWorkflowOnWorkflowOnv2Heading(
    $v3ProjectId: ID!
    $v2DocumentId: ID!
    $v2HeadingId: ID!
  ) {
    archiveWorkflowOnv2Heading(
      v3ProjectId: $v3ProjectId
      v2DocumentId: $v2DocumentId
      v2HeadingId: $v2HeadingId
    ) {
      status
      message
    }
  }
`;

const loadHeadingWorkflowIdQuery = gql`
  query {
    currentInstance {
      ... on Instance {
        _id
        projects {
          edges {
            node {
              _id
              legacyId
              activeHeadingWorkflowModel {
                _id
                defaultDisabled
              }
            }
          }
        }
      }
    }
  }
`;

const loadHeadingWorkflowModelQuery = gql`
  query headingWorkflowModel($v3ProjectId: ID!) {
    headingWorkflowModel(v3ProjectId: $v3ProjectId) {
      _id
      defaultDisabled
    }
  }
`;

export const loadCurrentInstance = async ({ client }) => {
  const {
    data: { currentInstance: data },
  } = await client.query({
    query: loadCurrentInstanceQuery,
  });
  return data;
};

export const updateDocGroupUsers = async (
  { groupId, addUserIds = [], removeUserIds = [] },
  { client }
) => {
  const {
    data: { addAndRemoveUsersProjectGroup: data },
  } = await client.mutate({
    mutation: updateGroupUsersMutation,
    variables: { groupId, addUserIds, removeUserIds },
  });
  return data;
};

export const loadWidgetConfig = async ({ workflowid }, { client }) => {
  const {
    data: {
      currentProject: {
        workflowwidgetsetting: { currentConfiguration: data },
      },
    },
  } = await client.query({
    query: loadWidgetConfigQuery,
    // variables: { workflowid },
    fetchPolicy: "no-cache",
  });
  return data;
};

export const loadCurrentWorkflowInstance = async (
  { id, mdContext: { document } },
  { client }
) => {
  const {
    data: {
      v2document: { workflowinstance: data },
    },
  } = await client.query({
    query: loadCurrentWorkflowInstanceQuery,
    variables: { id },
    fetchPolicy: "no-cache",
  });
  // check if we are in v2 & get v2 doc if possible
  if (window?.APPVERSION?.directory) {
    try {

      const v2Doclist = await fetchDocumentsInAProject();

      const v2Document = v2Doclist.find(
        ({ id: docId }) => `${docId}` === `${document?.split("-")[1]}`
      );

      return {
        instance: {
          ...data,
          v2Document,
        },
        allv2Documents: v2Doclist,
      };
      
    } catch (e) {
      console.error(e);
      return { instance: data };
    }
  }

  // Not in v2 - just return v3 data
  return { instance: data };
};

export const loadCurrentUserActions = async ({ client }) => {
  const {
    data: {
      myactions: { edges: data },
    },
  } = await client.query({
    query: loadCurrentUserActionsQuery,
    fetchPolicy: "no-cache",
  });
  return data;
};

export const loadAllGroups = async ({ client }) => {
  const { data: { currentProject: data } = {} } = await client.query({
    query: loadAllGroupsQuery,
    fetchPolicy: "no-cache",
  });
  return data;
};

// Added to reduce load in loadGroupsInProject
export const loadDocGroup = async ({ docId }, { client }) => {
  const { data: { docGroup: data } = {} } = await client.query({
    query: loadDocGroupQuery,
    fetchPolicy: "no-cache",
    variables: {
      docId,
    },
  });
  return data;
};

export const loadAvailableUsersInProject = async ({ client }) => {
  const { data: { availableUsersInProject: data } = {} } = await client.query({
    query: loadAvailableUsersInProjectQuery,
    fetchPolicy: "no-cache",
  });
  return data;
};

export const loadAssignableGroupsInProject = async ({ client }) => {
  const { data: { assignableGroupsInProject: data } = {} } = await client.query(
    {
      query: loadAssignableGroupsInProjectQuery,
      fetchPolicy: "no-cache",
    }
  );
  return data;
};

export const progressWorkflowStage = async (
  { id, etag, targetNextStage, formValues: { comment } = {}, v2DocumentId },
  { client }
) => {
  const { data: { progressWorkflowInstance: data } = {} } = await client.mutate(
    {
      mutation: progressWorkflowInstanceMutation,
      variables: { id, etag, comment, nextStage: targetNextStage, v2DocumentId },
    }
  );
  return data;
};

export const regressWorkflowStage = async (
  { id, etag, targetNextStage, formValues: { comment } = {} },
  { client }
) => {
  const { data: { regressWorkflowInstance: data } = {} } = await client.mutate({
    mutation: regressWorkflowInstanceMutation,
    variables: { id, etag, comment, prevStage: targetNextStage },
  });
  return data;
};

export const processWorkflowAction = async (
  { actionId, status, customStatus, formValues: { comment } },
  { client }
) => {
  const { data: { processAction: data } = {} } = await client.mutate({
    mutation: processActionMutation,
    variables: {
      id: actionId,
      input: {
        comment: comment || "",
        status: ["FULFILLED", "REJECTED", "CANCELLED"].includes(status)
          ? status
          : "FULFILLED",
        customStatus: `${status}-${customStatus}`,
      },
    },
  });
  return data;
};

export const gotoV2Document = ({ docId }) => {
  window?.app?.Duchess?.setCookie("CurrentDocumentID", docId);
  window?.app?.StateMachine?.handleEvent("EditDocument");
  return false;
};

export const updateWorkflowInstance = async (
  { updatedInstance, instanceId, rotateStage },
  { client }
) => {
  const { data: { updateWorkflowinstance: data } = {} } = await client.mutate({
    mutation: updateWorkflowInstanceMutation,
    // eslint-disable-next-line no-underscore-dangle
    variables: { id: instanceId, input: updatedInstance, rotateStage },
  });
  return data;
};

export const forceWorkflowToStage = async (
  { id, nextStage, etag, formValues: { comment } = {} },
  { client }
) => {
  const { data: { forceWorkFlowJump: data } = {} } = await client.mutate({
    mutation: forceWorkFlowJumpMutation,
    variables: { id, comment, nextStage, etag },
  });
  return data;
};

export const getCompoundRole = async ({ roleName }, { client }) => {
  const { data: { getRole: data } = {} } = await client.query({
    query: getRoleQuery,
    variables: { roleIdentifier: roleName },
  });
  return data;
};

export const createCompoundRole = async (
  { roleName, roleDescription, rolesIncluded },
  { client }
) => {
  const { data: { createRole: data } = {} } = await client.mutate({
    mutation: createRoleMutation,
    variables: { roleName, roleDescription, rolesIncluded },
  });
  return data;
};

export const addRoleToComposite = async (
  { roleName, rolesIncluded },
  { client }
) => {
  const { data: { addRoleToComposite: data } = {} } = await client.mutate({
    mutation: addRoleToCompositeMutation,
    variables: { roleName, rolesIncluded },
  });
  return data;
};

export const removeRoleFromComposite = async (
  { roleName, rolesIncluded },
  { client }
) => {
  const { data: { removeRoleFromComposite: data } = {} } = await client.mutate({
    mutation: removeRoleFromCompositeMutation,
    variables: { roleName, rolesIncluded },
  });
  return data;
};

export const createDocumentGroup = async ({ name }, { client }) => {
  const { data: { createProjectGroup: data } = {} } = await client.mutate({
    mutation: addGroupMutation,
    variables: { name },
  });
  return data;
};

export const grantMemberRoleToGroup = async (
  { roleIdentifier, groupId },
  { client }
) => {
  const { data: { grantRoleToGroup: data } = {} } = await client.mutate({
    mutation: grantMemberRoleToGroupMutation,
    variables: { roleIdentifier, groupId },
  });
  return data;
};

export const revokeRoleFromGroup = async (
  { roleIdentifier, groupId },
  { client }
) => {
  const { data: { revokeRoleFromGroup: data } = {} } = await client.mutate({
    mutation: revokeMemberRoleFromGroupMutation,
    variables: { roleIdentifier, groupId },
  });
  return data;
};

export const loadProjectWorkflowModelId = async ({ client }) => {
  const {
    data: { currentProject: data },
  } = await client.query({
    query: activeWorkflowModelQuery,
  });
  return data?.activeWorkflowModelId;
};

export const createWorkflowInstanceOnDocument = async (
  { docId, modelId },
  { client }
) => {
  const { data: { activeWorkflowOnv2Document: data } = {} } =
    await client.mutate({
      mutation: activateWorkflowOnDocumentMutation,
      variables: { parentIds: [docId], workflowmodel: modelId },
    });
  return data;
};

export const changeDocumentDefaultPermission = async (
  { permission },
  { client }
) => {
  const { data: { changeDocumentDefaultPermission: data } = {} } =
    await client.mutate({
      mutation: changeDocumentDefaultPermissionMutation,
      variables: { permission },
    });
  if (window?.app?.Modules?.Document) {
    window.app.Modules.Document.defaultRole = permission;
  }
  return data;
};

export const lockDocument = ({ docId, targetState }) => {
  if (window.lockDocument) {
    // Generate `why` string from v2
    const why = `Document ${targetState ? "LOCKED" : "UNLOCKED"} \n\tby ${
      window.app.Duchess.currentUser.firstname
    } ${window.app.Duchess.currentUser.lastname} <${
      window.app.Duchess.currentUser.email
    }> \n\ton ${DateTime.local().toLocaleString(
      DateTime.DATETIME_MED
    )}\n\tas role '${window.app.Duchess.currentUser.role}' \n\twith [gid=${
      window.app.Duchess.currentUser.gid
    }/uoid=${window.app.Duchess.currentUser.uoid}]`;

    return window.lockDocument(docId, targetState, why);
  }
  console.warn(`Attemted to lock document ${docId}, but not in v2 env`);
  return;
};

export const createHeadingWorkflowInstance = async (
  { ids, modelId, v3ProjectId },
  { client }
) => {
  const { data: { activeWorkflowOnv2Document: data } = {} } =
    await client.mutate({
      mutation: activateHeadingWorkflowOnDocumentMutation,
      variables: { parentIds: ids, workflowmodel: modelId },
      headers: {
        "x-scope-project": v3ProjectId,
      },
    });
  return data;
};

export const archiveHeadingWorkflow = async (
  { v3ProjectId, v2DocumentId, v2HeadingId },
  { client }
) => {
  const { data: { archiveWorkflowOnv2Heading: data } = {} } =
    await client.mutate({
      mutation: archiveHeadingWorkflowMutation,
      variables: { v3ProjectId, v2DocumentId, v2HeadingId },
    });
  return data;
};

export const loadV2Headings = async ({ mdContext }) => {
  // check if we are in v2 & get v2 doc if possible
  if (window?.APPVERSION?.directory && mdContext?.document) {
    try {
      const { object } = await new Promise((reso, rej) => {
        window.app.Duchess.readObject(
          "Document",
          {
            ID: mdContext?.document?.split("-")[1],
            populate: "conformsToStructure,conformsToStructure.headings",
          },
          (res) => {
            return res.success ? reso(res) : rej(res);
          }
        );
      });

      return object?.conformsToStructure?.headings || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  // Not in v2 - just return v3 data
  return [];
};

export const loadHeadingWorkflowId = async ({ client }) => {
  const { data: { currentInstance: data } = {} } = await client.query({
    query: loadHeadingWorkflowIdQuery,
    fetchPolicy: "no-cache",
  });
  return data?.projects?.edges[0]?.node?.activeHeadingWorkflowModel || {};
};

export const v2WorkflowActionResult = async ({ actionResult }) => {
  // check if we are in v2 & get v2 doc if possible
  if (window?.app?.Duchess) {
    const channel = `/duchess/HeadingWorkflowModified/${actionResult.documentId}`;
    try {
      // TODO: add an incrementing ID (tied to project/doc) for each message? so that the frontend can tell if it misses any messages
      window.app.Duchess.PublishUpdate(channel, { actionResult });
    } catch (e) {
      console.error("workflowWidget.api.v2WorkflowActionResult", e);
    }
  }
};

export const assignV2DocumentMembers = async ({ members }) => {
  if (window?.Document?.members) {
    Object.assign(window.Document.members, members);
  }
};

export const assignV2DocumentAssignableUsers = async ({ assignableUsers }) => {
  if (window?.Document?.assignableUsers) {
    Object.assign(window.Document.assignableUsers, assignableUsers);
  }
};

export const assignV2DocumentAssignableGroups = async ({
  assignableGroups,
}) => {
  if (window?.Document?.assignableGroups) {
    Object.assign(window.Document.assignableGroups, assignableGroups);
  }
};

export const getDocumentList = async () => {
  // check if we are in v2 & get v2 doc if possible
  if (window?.APPVERSION?.directory) {
    try {
      const doc = await new Promise((reso, rej) => {
        window.app.Duchess.listObject(
          "Document",
          {
            filterBy: "usedInProject",
            filter: window.app.Duchess.getCookie("CurrentProjectID"),
          },
          (res) => {
            return res.success ? reso(res) : rej(res);
          }
        );
      });

      const { list: documentList, success, message } = doc;

      if (success) return documentList || [];
      throw new Error(message);
    } catch (e) {
      console.error(e);
      return [];
    }
  }
};

export const loadHeadingWorkflowModel = async ({ v3ProjectId }, { client }) => {
  const { data: { headingWorkflowModel: data } = {} } = await client.query({
    query: loadHeadingWorkflowModelQuery,
    fetchPolicy: "no-cache",
    variables: {
      v3ProjectId,
    },
  });
  return data || {};
};
